import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';
import { mockFullLoggedOutUser } from './mockFullLoggedOutUser';

export const mockLoggedOutUserNoConsent: MockResponseConfig = {
  ...mockFullLoggedOutUser,
  UnifiedProfileQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          ...mockFullLoggedOutUser.UnifiedProfileQuery(variables).data.unified
            .unifiedProfile,
          username: 'loggedoutnoconsent',
          isProfileOwnerConsented: false,
        },
      },
    },
  }),
}; 